import type { Snapshot } from "./types";

interface ErrorEnvelope {
  error?: {
    code?: string;
    message?: string;
  };
}

export class APIError extends Error {
  constructor(
    message: string,
    readonly status: number,
    readonly code: string,
  ) {
    super(message);
    this.name = "APIError";
  }
}

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(path, {
    ...init,
    cache: "no-store",
    credentials: "same-origin",
    headers: {
      Accept: "application/json",
      ...init?.headers,
    },
  });
  if (!response.ok) {
    let envelope: ErrorEnvelope = {};
    try {
      envelope = (await response.json()) as ErrorEnvelope;
    } catch {
      // A proxy or transient upstream can return a non-JSON error page.
    }
    throw new APIError(
      envelope.error?.message ?? "Could not reach the attendance list.",
      response.status,
      envelope.error?.code ?? "request_failed",
    );
  }
  return (await response.json()) as T;
}

export function fetchAttendance(token: string): Promise<Snapshot> {
  return request<Snapshot>(`/api/e/${encodeURIComponent(token)}`);
}

export function setAttendance(token: string, memberId: string, attending: boolean): Promise<Snapshot> {
  return request<Snapshot>(
    `/api/e/${encodeURIComponent(token)}/members/${encodeURIComponent(memberId)}`,
    {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ attending }),
    },
  );
}

export function endpointToken(pathname: string, search = ""): string | null {
  const match = pathname.match(/^\/e\/([^/]+)\/?$/);
  if (match) {
    try {
      return decodeURIComponent(match[1]);
    } catch {
      return null;
    }
  }
  const queryToken = new URLSearchParams(search).get("endpoint");
  return queryToken?.trim() || null;
}

